import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import { appFetchJson } from "../../../utils/http";
import apiRoutes from "../../../api/apiRoutes";
import EessMultiSelect from "../../../components/multiselect/EessMultiSelect";
import ProductoAutocomplete from "../../../components/autocomplete/ProductoAutocomplete";
import InputNumberNoScroll from "../../../components/inputs/inputNumberNoScroll";

export default function CrearPrecioProductoEess({
  onClose = () => {},
  onCreated = () => {},
}) {

  // Función para obtener fecha actual YYYY-MM-DD
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // --- ESTADOS ---
  const [fecha, setFecha] = useState(getTodayDate());
  const [eessSel, setEessSel] = useState([]);
  const [selectedProducto, setSelectedProducto] = useState(null);
  const [valorPrecio, setValorPrecio] = useState("");
  //const [precioCompra, setPrecioCompra] = useState("");
  const [saving, setSaving] = useState(false);
  //const isValid = eessSel.length > 0 && selectedProducto !== null && fecha !== "";
  const isValid = eessSel.length > 0 && selectedProducto !== null && fecha !== "" && valorPrecio !== "" && Number(valorPrecio) > 0;

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const guardar = async () => {
    if (!isValid || saving) return;
    setSaving(true);

    try { 

      const promesas = eessSel.map(async (idEstacion) => {
        const payload = {
          eessId: idEstacion,
          productoId: selectedProducto?.id,
          fecha: fecha, // Usamos el estado dinámico                  
          precio: valorPrecio ? Number(valorPrecio) : 0,
          //precio2: precioCompra ? Number(precioCompra) : 0 
        };

        return appFetchJson(apiRoutes.precioProductoEess.create, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      });

      await Promise.all(promesas);

      if (onCreated) onCreated();
      onClose();

    } catch (e) {
      console.error("Error Backend:", e);
      alert(`Error al guardar: ${e.message || "Error 500"}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Crear Precio Producto por EE.SS.</h2>
          <button className="modal-close-x" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="modal-body flex flex-col items-start">
          
          <p className="text-gray-600 mb-6 italic text-left w-full px-8">
            Introduzca los datos de Precio Producto EE.SS.
          </p>

          {/* SECCIÓN SUPERIOR */}
          <div className="flex flex-col gap-3 mb-6 w-full px-8">
            <div className="flex items-center">
              <label className="w-32 shrink-0 text-left font-bold">EE.SS.*:</label>
              <div className="w-[600px]">
                <EessMultiSelect value={eessSel} onChange={setEessSel} className="w-full" />
              </div>
            </div>

            <div className="flex items-center">
              <label className="w-32 shrink-0 text-left font-bold">Fecha:</label>
              <div className="w-[600px]">
                <input
                  type="date"
                  className="input w-full h-[38px] bg-gray-200 border rounded px-3"
                  value={fecha}
                  readOnly
                />
              </div>
            </div>
          </div>

          {/* CORRECCIÓN DE ALINEACIÓN DE PESTAÑA:
             Usamos 'px-0' para quitar el padding y que se pegue totalmente a la izquierda,
             alineándose con el borde del contenedor padre, tal como muestra tu línea roja.
          */}
          <div className="flex mb-0 w-full"> {/* Quitamos px-8 y aseguramos w-full */}
            <button className="bg-green-700 text-white px-6 py-2 rounded-t-md font-medium text-sm">
              Precio por Producto
            </button>
          </div>

          {/* CONTENEDOR GRIS */}
          <div className="bg-gray-100 p-8 rounded-b-md rounded-tr-md space-y-5 w-full">
            <div className="flex items-center">
              <label className="w-32 shrink-0 text-left font-bold">Producto*:</label>
              <div className="w-[600px]">
                <ProductoAutocomplete value={selectedProducto} onChange={setSelectedProducto} className="w-full" />
              </div>
            </div>

           <div className="flex items-center mt-6">
              <label className="w-32 shrink-0 text-left font-bold">Valor Precio:</label>
              <div className="w-[600px]">
                <InputNumberNoScroll
                  className="input w-full h-[38px] bg-white border rounded px-3"
                  value={valorPrecio}
                  onChange={(e) => setValorPrecio(e.target.value)}
                />
              </div>
            </div>

            {/*<div className="flex items-center">
              <label className="w-32 shrink-0 text-left font-bold">Precio Compra:</label>
              <div className="w-[600px]">
                <InputNumberNoScroll
                  className="input w-full h-[38px] bg-white border rounded px-3"
                  value={precioCompra}
                  onChange={(e) => setPrecioCompra(e.target.value)}
                />
              </div>
            </div>*/}

          </div>
        </div>

        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar label="Guardar" isValid={isValid} saving={saving} onClick={guardar} />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}